import React from "react";
import Sizes from "./common/sizes";
import {Button, ButtonTypes} from "./buttons";
import CoalesceFunction from "../../../../helper/coalesceFunction";

export function Modal({ children, title, size = null, buttons = [], onButtonClicked, onClose }) {
    let sizeClass = '';
    switch(size) {
        case Sizes.sm:
        case Sizes.lg:
            sizeClass = 'modal-' + size;
            break;
    }

    onButtonClicked = CoalesceFunction(onButtonClicked);

    return <div className={'modal active ' + sizeClass}>
        <a onClick={onClose} className="modal-overlay" />
        <div className={'modal-container'}>
            <ModalHeader title={title} onClose={onClose} />
            <ModalBody>
                {children}
            </ModalBody>
            <ModalFooter>
                {
                    buttons.map(button =>
                        <Button buttonTypes={[ButtonTypes.primary]} key={button.value} onClick={onButtonClicked.bind(null, button.value)}>{button.content}</Button>
                    )
                }
            </ModalFooter>
        </div>
    </div>;
}

function ModalHeader({ title, onClose }) {
    return <div className={'modal-header'}>
        <button className="btn btn-clear float-right" onClick={onClose}></button>
        <div className={'modal-title h5'}>{title}</div>
    </div>;
}

function ModalBody({ children }) {
    return <div className={'modal-body'}>
        <div className={'content'}>
            {children}
        </div>
    </div>;
}

function ModalFooter({ children }) {
    return <div className={'modal-footer'}>{children}</div>;
}
